const products = [
	// 慢走丝
	{
		id: 1,
		name: '慢走丝',
		category: 1,
		image: require('@/assets/imgs/case/慢走丝1.jpg'),
	},
	{
		id: 1,
		name: '慢走丝',
		category: 1,
		description: '行程：800MM X 500MM',
		image: require('@/assets/imgs/case/慢走丝2.jpg'),
	},
	{
		id: 1,
		name: '慢走丝',
		category: 1,
		image: require('@/assets/imgs/case/慢走丝3.jpg'),
	},
	
	// CNC加工中心
	{
		id: 1,
		name: 'CNC加工中心',
		category: 1,
		description: '行程：3100MM X 2000MM',
		image: require('@/assets/imgs/case/CNC加工中心1.jpg'),
	},
	{
		id: 1,
		name: 'CNC加工中心',
		category: 1,
		image: require('@/assets/imgs/case/CNC加工中心2.jpg'),
	},
	{
		id: 1,
		name: 'CNC加工中心',
		category: 1,
		image: require('@/assets/imgs/case/CNC加工中心3.jpg'),
	},
	
	// 冲压车间
	{
		id: 1,
		name: '冲压车间',
		category: 1,
		description: '500T-400T-315T 6台多连杆式自动化生产线',
		image: require('@/assets/imgs/case/冲压车间2.jpg'),
	},
	{
		id: 1,
		name: '试模冲床800吨',
		category: 1,
		description: '冲床台面：3400MM X 1400MM',
		image: require('@/assets/imgs/case/冲压车间3.jpg'),
	},
	{
		id: 1,
		name: '试模冲床500吨',
		category: 1,
		description: '冲床台面：3400MM X 1400MM',
		image: require('@/assets/imgs/case/冲压车间4.jpg'),
	},
	{
		id: 1,
		name: '试模冲床110吨\n试模冲床250吨 ',
		category: 1,
		description: '冲床台面：1150MM X 680MM\n冲床台面：2200MM X 920MM',
		image: require('@/assets/imgs/case/冲压车间1.jpg'),
	},
	
	// 磨床
	{
		id: 1,
		name: '平面研磨',
		category: 1,
		description: '行程：650MM X 200MM',
		image: require('@/assets/imgs/case/磨床1.jpg'),
	},
	{
		id: 1,
		name: '大水磨',
		category: 1,
		description: '行程：1500MM X 600MM',
		image: require('@/assets/imgs/case/磨床2.jpg'),
	},
	
	// 检测设备
	{
		id: 1,
		name: '检测设备',
		category: 1,
		image: require('@/assets/imgs/case/检测1.jpg'),
	},
	{
		id: 1,
		name: '检测设备',
		category: 1,
		image: require('@/assets/imgs/case/检测2.jpg'),
	},
	{
		id: 1,
		name: '检测设备',
		category: 1,
		image: require('@/assets/imgs/case/检测3.jpg'),
	},
]

const caseList = [
	{
		name: '气压式冲床',
		stroke: '800T',
		qry: '1台',
		brand: '广东锻造'
	},
	{
		name: '气压式冲床（+连续机械手）',
		stroke: '500T',
		qry: '1台',
		brand: '扬力集团'
	},
	{
		name: '气压式冲床（+连续机械手）',
		stroke: '400T',
		qry: '2台',
		brand: '扬力集团'
	},
	{
		name: '气压式冲床（+连续机械手）',
		stroke: '315T',
		qry: '3台',
		brand: '扬力集团'
	},
	{
		name: '气压式冲床',
		stroke: '350T',
		qry: '1台',
		brand: '广东锻造'
	},
	{
		name: '气压式冲床',
		stroke: '250T',
		qry: '1台',
		brand: '台湾协易'
	},
	{
		name: '气压式冲床',
		stroke: '110T',
		qry: '2台',
		brand: '台湾协易'
	},
	{
		name: '慢走丝线割机',
		stroke: '900*600',
		qry: '21台',
		brand: '日本法兰克、庆鸿'
	},
	{
		name: '数控铣床',
		stroke: '3100*2000\n1200*600',
		qry: '15台',
		brand: '台湾乔威进'
	},
	{
		name: '平面磨床',
		stroke: '650*200',
		qry: '7台',
		brand: '台湾建德'
	},
	{
		name: '大水磨',
		stroke: '1500*600',
		qry: '5台',
		brand: '台湾建德'
	},
	{
		name: '旋转钻',
		stroke: '900*600',
		qry: '2台',
		brand: '台湾建德'
	},
	{
		name: '放电机',
		stroke: '350*250',
		qry: '2台',
		brand: '杰克斯'
	},
	{
		name: '细孔放电器',
		stroke: '300*200',
		qry: '1台',
		brand: '台湾嘉升'
	},
	{
		name: '整平机',
		stroke: '9轴*150',
		qry: '1台',
		brand: '昆山德成'
	},
	{
		name: '压铆机',
		stroke: '6T',
		qry: '1台',
		brand: '东莞超快'
	},
	{
		name: '三元测量仪',
		stroke: '1500*1300*600',
		qry: '1台',
		brand: '台湾维鸿'
	},
	{
		name: '2.5元测量仪',
		stroke: '2200*600*300',
		qry: '1台',
		brand: '三友'
	},
	{
		name: '手持光谱仪',
		stroke: '',
		qry: '1台',
		brand: '奥林巴斯'
	},
]

export { products, caseList } 